const server = process.env.REACT_APP_API_URL;
const apiPath = `${server}/api`;
export const walletsRoute = `${apiPath}/wallets`;
export const movementsRoute = `${apiPath}/movements`;
export const categoriesRoute = `${apiPath}/categories`;
export const expensesRoute = `${apiPath}/expenses`;